import React, { useState } from "react";
import CircularProgress from "@mui/material/CircularProgress";
const AIContent = ({ taskDetail }) => {
  const [isLoading, setIsLoading] = useState(false);
  const handleGetContent = async () => {
    setIsLoading(true);
    window.open(`/generate-content`, "_blank");
   /*  try {
      const response = await fetch(
        "https://llmapi.ecommcube.com/api/generate-titles",
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${process.env.REACT_APP_API_TOKEN_FOR_CONTENT}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            input_str: `${taskDetail?.industry_name} ${taskDetail?.city}`,
            category: taskDetail?.industry_name,
            input_no_of_titles: 5,
          }),
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();

      const storageKey = "titles";

      sessionStorage.removeItem(storageKey);
      sessionStorage.setItem(storageKey, JSON.stringify(data.response));

      window.open(`/generate-content?key=${storageKey}`, "_blank");
    } catch (error) {
      console.error("Error fetching content:", error);
    } */
    setIsLoading(false);
  };

  return (
    <div>
      <button
        onClick={handleGetContent}
        className="btnPrimary disabled:cursor-not-allowed mt-2"
      >
        Get Content{" "}
        {isLoading ? (
          <CircularProgress
            size="25px"
            sx={{ color: "white", marginLeft: "1px" }}
          />
        ) : null}
      </button>
    </div>
  );
};

export default AIContent;
